import { reportsReducer } from './reports';

const reportsRootReducer = {
  reports: reportsReducer,
};

export { reportsRootReducer };
